import type { ComponentCommonProps, Shape, Theme, Video, Img } from '../../types/props.js'

export interface MediaPlayerBaseProps extends ComponentCommonProps, React.HTMLAttributes<HTMLDivElement> {
  data: {
    sticky?: boolean
    shape?: Shape
    theme?: Theme
    title?: string
    videoTitle?: string
    btnText?: string
    img?: Img
    isYouTube?: boolean
    video?: Video
    mobileVideo?: Video
    youtubeId?: string
    titleAnimation?: 'fade-in' | null
  }
  onBtnClick?: () => void
}
